import PropTypes from 'prop-types';
import React from 'react';
import SnackbarUtils from 'utils/SnackbarUtils';
import GenericContent from '../../../../../components/CrudWithSteps/components/GenericContent';
import {
  CONTRATO_STATUS_EM_EDICAO,
  CONTRATO_STATUS_APROVADO,
  CONTRATO_STATUS_NEGADO,
} from '../../../../../library/ContratoStatus';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_DISTRATO,
} from '../../../../../library/ContratoVersoes';

class GenericDados extends GenericContent {
  getSubmitMessageSuccess = (data) => {
    if (this.editing()) {
      switch (data.versaoContrato) {
        case CONTRATO_VERSAO_ADITIVO:
          return this.props.languageValues.successAditivoSalvar;
        case CONTRATO_VERSAO_DISTRATO:
          return this.props.languageValues.successDistratoSalvar;
        default:
          return this.props.languageValues.successContratoSalvar;
      }
    }
    switch (data.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.successAditivoPreCadastro;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.successDistratoPreCadastro;
      default:
        return this.props.languageValues.successContratoPreCadastro;
    }
  };

  getSubmitMessageError = (data) => {
    if (this.editing()) {
      switch (data.versaoContrato) {
        case CONTRATO_VERSAO_ADITIVO:
          return this.props.languageValues.erroAditivoSalvar;
        case CONTRATO_VERSAO_DISTRATO:
          return this.props.languageValues.erroDistratoSalvar;
        default:
          return this.props.languageValues.erroContratoSalvar;
      }
    }
    switch (data.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.erroAditivoPreCadastro;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.erroDistratoPreCadastro;
      default:
        return this.props.languageValues.erroContratoPreCadastro;
    }
  };

  toSubmit = (index, data, callbackStart, callbackSuccess, callbackError) => {
    if (index < this.props.totalBullets - 1) {
      this.toNextContent();
      return;
    }
    if (!this.hasPermissions()) {
      return;
    }
    if (typeof callbackStart === 'function') {
      callbackStart();
    }
    data.versaoContrato = this.props.versaoContrato;
    this.props.contratoEntePublicoRegisterPreEtapa(
      data,
      (resp) => {
        SnackbarUtils.enqueueSnackbar({
          message: this.getSubmitMessageSuccess(data),
          options: {
            variant: 'success',
          },
        });
        if (typeof callbackError === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText || this.getSubmitMessageError(data),
          options: {
            variant: 'error',
          },
        });
        if (typeof callbackError === 'function') {
          callbackError();
        }
      }
    );
  };

  editing = () => {
    return this.props.editing || false;
  };

  disabledWhenAditivo = () => {
    if (
      this.props.contratosEntePublico.contratoEditing.versaoContrato ===
      CONTRATO_VERSAO_ADITIVO
    ) {
      return true;
    }
    return false;
  };

  disabledWhenDistrato = () => {
    if (
      this.props.contratosEntePublico.contratoEditing.versaoContrato ===
      CONTRATO_VERSAO_DISTRATO
    ) {
      return true;
    }
    return false;
  };

  hasPermissions = () => {
    if (!this.props.contratosEntePublico.contratoEditing.ativo) {
      return false;
    }
    if (this.editing()) {
      return [
        CONTRATO_STATUS_EM_EDICAO,
        CONTRATO_STATUS_APROVADO,
        CONTRATO_STATUS_NEGADO,
      ].indexOf(this.props.contratosEntePublico.contratoEditing.flgStatus) > -1
        ? true
        : false;
    }
    return (
      this.props.contratosEntePublico.contratoEditing.flgStatus <=
        CONTRATO_STATUS_EM_EDICAO &&
      this.props.auth.userPermissions.contratos.entePublico.register
    );
  };

  codCoopValueIsValid = () => {
    return this.props.contratosEntePublico.contratoEditing.codCoop.length > 0
      ? {
          status: true,
        }
      : {
          status: false,
          error: this.props.languageValues.validations.cooperativa.required,
        };
  };

  setValue = (event, callback) => {
    let newEvent = { ...event };
    if (newEvent.target.name === 'totalMeses') {
      newEvent.target.value = !newEvent.target.value
        ? 0
        : Number(newEvent.target.value).toString();
    }
    const isDifferent =
      this.props.contratosEntePublico.contratoEditing[newEvent.target.name] !==
      newEvent.target.value;
    this.setState(
      {
        ...this.state,
        [newEvent.target.name + 'Changed']: isDifferent
          ? true
          : this.state[newEvent.target.name + 'Changed'],
      },
      () => {
        if (typeof callback === 'function') {
          callback();
        }
      }
    );
    this.props
      .changeContratoEntePublicoEditingValue(
        newEvent.target.name,
        newEvent.target.value
      )
      .then(() => {
        const method = newEvent.target.name + 'ValueChanged';
        if (typeof this[method] === 'function') {
          this[method]();
        }
      });
  };

  render() {
    return <></>;
  }
}

GenericDados.propTypes = {
  versaoContrato: PropTypes.number,
  editing: PropTypes.bool,
  loading: PropTypes.bool,
  totalBullets: PropTypes.number.isRequired,
  bulletsIndex: PropTypes.number.isRequired,
};

export default GenericDados;
